import app from '../app';
import Page, { IPageAttrs } from '../../common/components/Page';
import NotificationList from '../components/NotificationList';
import type Mithril from 'mithril';
import extractText from '../../common/utils/extractText';
import NotificationListState from '../states/NotificationListState';
import avatar from '../../common/helpers/avatar';
import RoleBindingModal from './RoleBindingModal';
import GiftPackModal from './GiftPackModal';
import MallPage from './MallPage';

/**
 * The `LikesPage` component shows the notifications list. It is only
 * used on mobile devices where the notifications dropdown is within the drawer.
 */
export default class MallOrderPage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
  originalMoney = 0;
  discountMoney = 0;
  money = 0;
  orderTime = '';
  nickName = '';
  roleInfo = '';
  chargeName = '';
  orderId = '';
  quantity =1;
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);
    app.history.push('notifications', extractText(app.translator.trans('dl-person.forum.mallorder')));

    app.notifications = new NotificationListState({
      filter: { type: ['postMallOrdered'] },
      // sort: 'newest',
    });

    app.notifications.load();
    // app.notifications.refreshParams(param);

    this.bodyClass = 'App--notifications';

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const orderId = urlParams.get('orderId');
    const status = urlParams.get('status');
    if (status === 'troubled' || status === 'FAILED' || status === 'CLOSED') {
      m.route.set(app.route('pay.mall', { type: 'postPayed' }));
      return
    }
    this.orderId = orderId;
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + `/sdkOrderDetail?orderId=${orderId}`,
      })
      .then((res) => {
        if (res != null && res != undefined && res != []) {
          // 返回的数组[排序,id,名称,金额,描述,图片,限制,剩余限制,[奖品id,奖品数量,奖品icon,奖品名字]]
          this.originalMoney = res.originalMoney;
          this.money = res.money;
          this.discountMoney = (this.originalMoney - this.money).toFixed(2);
          const date = new Date(res.orderTime);
          // 时间转换
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补齐两位数
          const day = String(date.getDate()).padStart(2, '0'); // 补齐两位数
          const hours = String(date.getHours()).padStart(2, '0'); // 补齐两位数
          const minutes = String(date.getMinutes()).padStart(2, '0'); // 补齐两位数
          const secondsStr = String(date.getSeconds()).padStart(2, '0'); // 补齐两位数
          this.orderTime = `${year}-${month}-${day} ${hours}:${minutes}:${secondsStr}`;
          this.nickName = res.nickName;
          this.roleInfo = res.roleName + '-' + res.zoneId;
          this.chargeName = res.chargeName;
          this.quantity = res.quantity;
          m.redraw();
        }
      });
  }

  view() {
    return (
      <div className="Mall">
        {MallPage.prototype.MallUserInfo(false)}
        <div className="Order-bg">
          <div className="Order">
            <div className="Order-box">
              <div className="Order-title">{app.translator.trans('dl-pay.forum.order.confirm_payment_order')}</div>
              <div className="Order-details">
                <div className="Order-number">USD {this.money}</div>
                <div className="Order-content">
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.original_price_of_goods')}:</span>
                    <span className="right">USD {this.originalMoney}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.discount_amount')}:</span>
                    <span className="right">USD {this.discountMoney}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.coupon')}:</span>
                    <span className="right">-</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.recharge_games')}:</span>
                    <span className="right">{this.nickName}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.role_information')}</span>
                    <span className="right"><span>{this.roleInfo}</span>{app.translator.trans('dl-pay.forum.user.srvId_count')}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.product_information')}:</span>
                    <span className="right">{this.chargeName}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.product_quantity')}:</span>
                    <span className="right">{this.quantity}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.order_number')}:</span>
                    <span className="right">{this.orderId}</span>
                  </div>
                  <div className="item">
                    <span className="left">{app.translator.trans('dl-pay.forum.order.order_placemen_time')}:</span>
                    <span className="right">{this.orderTime}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="Order-btn"
              onclick={() => {
                this.onNavBack();
              }}
            >
              {app.translator.trans('dl-pay.forum.operation.return_to_the_mall')}
            </div>
          </div>
          <div className="Order-explain">
            <div className="title">{app.translator.trans('dl-pay.forum.operation.recharge_instructions')}</div>
            <p>{app.translator.trans('dl-pay.forum.operation.recharge_instructions_text')}</p>
          </div>
        </div>
      </div>
    );
  }
  onNavBack() {
    m.route.set(app.route('pay.mall', { type: 'postMalled' }));
  }
}
